import { Popup } from 'components/Popup'
import { Typography } from 'components/Typography'
import { useBankAccountPopup } from './Providers/BankAccountPopupProvider'
import { BUTTON_TYPES, Button } from 'components/Button'
import { BTN_TXT, NOTIFICATIONS } from 'constants/txt'
import { useCallback } from 'react'
import { setLoading } from 'redux/store/common/slice'
import { updateBankAccountDetails } from './api'
import { useDispatch } from 'react-redux'
import { notification } from 'antd'

export const SetAsDefaultReceivableBankAccount = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  const {
    setAsDefaultReceivableAccountPopup: { state, actions }
  } = useBankAccountPopup()

  const { name, uuid, business_account_id } = state.payload

  const dispatch = useDispatch()

  const setAsDefaultReceivableAccount = useCallback(async () => {
    if (!uuid || !business_account_id) return
    try {
      dispatch(setLoading(true))
      await updateBankAccountDetails(business_account_id, uuid, {
        is_default: true
      })
      onSuccess()
    } catch (error) {
      console.error(error)
      notification.error({
        message: NOTIFICATIONS.SOMETHING_WENT_WRONG
      })
    } finally {
      dispatch(setLoading(false))
      actions.close()
    }
  }, [uuid, business_account_id, dispatch, onSuccess, actions])

  return (
    <Popup
      {...state}
      zIndex={10000}
      width={442}
      onCancel={actions.close}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={actions.close} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={setAsDefaultReceivableAccount}
            upperCase
          >
            {BTN_TXT.SET_AS_DEFAULT}
          </Button>
        </>
      }
    >
      <Typography.Body1>
        {/*TODO: to change this text*/}
        Future receivable payments and payouts for this BusinessEntity will
        route to {name} instead of the сurrent default account.
      </Typography.Body1>
    </Popup>
  )
}
